// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"902f8aff","472":"bdbeecde","596":"3b3a097f"}[chunkId] + ".chunk.css";
};